import React, { ReactNode } from 'react';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip';
import { Box, BoxProps } from '@mui/material';
import InfoIcon from '@/public/icons/info.svg';
import { PopOverBox, PopOverBoxHeader, PopOverBoxInner } from './styles';

type CustomTooltipOption = {
  offset: number[];
};

type P = {
  option?: CustomTooltipOption;
  children?: React.ReactElement<any, any>;
} & Omit<TooltipProps, 'children'>;

export const CustomTooltipTitle = ({ children }: { children: ReactNode }) => {
  return (
    <Box style={{ padding: '16px', fontSize: '14px', color: '#888D96' }}>
      {children}
    </Box>
  );
};

export const CustomTooltipBox = ({
  title,
  content,
  ...props
}: {
  title: ReactNode;
  content: ReactNode;
} & Omit<BoxProps, 'content'>) => {
  return (
    <PopOverBox {...props}>
      <PopOverBoxHeader>
        <Box>{title}</Box>
      </PopOverBoxHeader>
      <PopOverBoxInner sx={{ px: 2, py: 3 }}>{content}</PopOverBoxInner>
    </PopOverBox>
  );
};

const CustomTooltip = ({ option, children, title, placement, ...props }: P) => {
  return (
    <LightTooltip
      {...props}
      title={title}
      placement={placement ?? 'right-start'}
      slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: option?.offset ?? [0, -10],
              },
            },
          ],
        },
      }}
    >
      {children ? (
        children
      ) : (
        <Box width={'20px'} height={'20px'}>
          <InfoIcon />
        </Box>
      )}
    </LightTooltip>
  );
};

export default CustomTooltip;

const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: '0px 6px 12px 0px rgba(0, 0, 0, 0.08)',
    fontSize: 11,
    padding: 0,
  },
}));
